import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared-module';
@NgModule({
  declarations: [],
  exports: [ReactiveFormsModule, SharedModule],
  imports: [SharedModule, ReactiveFormsModule],
})
export class InputsModule {}
